import LoadingSpinnerPlaceholder from './loadingSpinnerPlaceholder'

export default LoadingSpinnerPlaceholder
